// Labels and limits of the Source tab. Limits mirror the backend (reminder_setup/source/controller.js).

export const MAX_RELATION_DEPTH = 2;
export const MAX_RELATIONS = 10;
export const MAX_PATHS = 200;
export const PREVIEW_ROW_LIMIT = 20;
export const DEFAULT_PAGE_SIZE = 5000;
export const KEY_RE = /^[a-z][a-z0-9_]{1,49}$/;

export const SUBJECT_TYPE_OPTIONS = [
  { value: "USER", label: "User", hint: "Each row is about one user (client, admin or employee)." },
  { value: "NONE", label: "Platform", hint: "Rows are about the platform itself, e.g. a SendGrid plan expiry." },
];
